module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Little-Drummer-Girl.8a22704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Little-Drummer-Girl.jpg
// module id = A1r3
// module chunks = 0